/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Describes the type of legend badge that represents a series in a legend
 */
export var LegendItemBadgeShape = /*@__PURE__*/ (function (LegendItemBadgeShape) {
    /**
     * Specifies automatic badge with best match of series type, e.g. Square badge for Area Series, Line badge for Line Series etc.
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Automatic"] = 0] = "Automatic";
    /**
     * Specifies a circle badge in a legend
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Circle"] = 1] = "Circle";
    /**
     * Specifies a thin line badge in a legend
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Line"] = 2] = "Line";
    /**
     * Specifies a square badge in a legend
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Square"] = 3] = "Square";
    /**
     * Specifies a marker badge in a legend (if series supports markers otherwise a circle badge)
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Marker"] = 4] = "Marker";
    /**
     * Specifies a thick horizontal bar in a legend
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Bar"] = 5] = "Bar";
    /**
     * Specifies a thick vertical column in a legend
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Column"] = 6] = "Column";
    /**
     * Specifies hidden badge in a legend, next to the series title
     */
    LegendItemBadgeShape[LegendItemBadgeShape["Hidden"] = 7] = "Hidden";
    return LegendItemBadgeShape;
})({});
/**
 * @hidden
 */
export var LegendItemBadgeShape_$type = /*@__PURE__*/ markEnum('LegendItemBadgeShape', 'Automatic,0|Circle,1|Line,2|Square,3|Marker,4|Bar,5|Column,6|Hidden,7');
